import { doAttention } from '@/attention';
export function headShake(el, duration = undefined, options = {}) {
    return doAttention(el, 'headShake', duration, options);
}
//# sourceMappingURL=headShake.js.map